import { render } from "./upload_videos.vue?vue&type=template&id=4ef69d2a&scoped=true"
import script from "./upload_videos.vue?vue&type=script&lang=js"
export * from "./upload_videos.vue?vue&type=script&lang=js"

import "./upload_videos.vue?vue&type=style&index=0&id=4ef69d2a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef69d2a"]])

export default __exports__